import styled from 'styled-components'
import {
  primary,
  primarySoft,
  bgPrimaryLight,
  primaryGradient,
  brandDark,
  surface,
  text,
  muted,
  borderSoft,
  boxShadow,
  shadowActive,
  radiusSm,
  radiusMd,
  widthFull,
  widthResize,
  heightHeader,
  widthWithPadding,
  widthResizeWithPadding,
} from '../Resources/Theme'

const Nav = styled.div`
  position: fixed;
  width: ${props => props.resize && !props.resizeOpen ? widthResize : widthFull};
  height: 100%;
  background: ${surface};
  border-right: 1px solid ${borderSoft};
  overflow: hidden;
  transition: .35s ease;
  z-index: 99;
  box-shadow: none;

  &:hover {
    overflow: auto;
    overflow-x: hidden;
  }

  &::-webkit-scrollbar-track {
    background-color: ${surface};
    position: fixed;
    margin-top: ${heightHeader};
  }

  &::-webkit-scrollbar {
    width: .3rem;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${borderSoft};
    border-radius: 6px;
  }

  @media (max-width: 992px) {
    width: ${widthFull};
    margin-left: -${props => props.mobile ? '0' : '280'}px;
    overflow: auto;
    overflow-x: hidden;
    box-shadow: ${boxShadow};
  }
`

Nav.Bg = styled.div`
  display: none;
  z-index: 99;

  @media (max-width: 992px) {
    display: ${props => props.mobile ? 'block' : 'none'};
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: ${bgPrimaryLight};
    backdrop-filter: blur(2px);
  }
`
Nav.Title = styled.li`
  height: 29px;
  width:  ${props => props.resize && !props.resizeOpen ? widthResizeWithPadding : widthWithPadding};
  font-weight: 500;
  color: ${muted};
  padding-top: 0px;
  padding-bottom: 10px;
  display: flex;
  justify-content: ${props => props.resize && !props.resizeOpen ? 'center' : ''};
  span {
    display: ${props => props.resize && !props.resizeOpen ? 'none' : 'block'};
    align-self: center;
  }
  i {
    display: ${props => props.resize && !props.resizeOpen ? 'block' : 'none'};
    align-self: center;
  }

  @media (max-width: 992px) {
    display: block;
    justify-content: flex-start;
    width: ${widthWithPadding};

    span {
      display: block;
    }
    i {
      display: none;
    }
  }
`
Nav.Swipe = styled.div`
  display: none;
  position: fixed;
  width: 30px;
  height: 100%;
  z-index: 1;
  
  @media (max-width: 992px) {
    display: block;
  }
`

/* Start Brand */
Nav.Brand = styled.div`
  color: #fff;
  position: fixed;
  width: ${props => props.resize && !props.resizeOpen ? widthResize : widthFull};
  height: ${heightHeader};
  display: flex;
  justify-content: space-between;
  background: ${brandDark};
  padding: 0 ${props => props.resize && !props.resizeOpen ? '4' : '12'}px;
  transition: .35s ease;
  border-bottom: 1px solid rgba(255,255,255,0.06);
  z-index: 1;

  @media (max-width: 992px) {
    padding: 0 20px;
    justify-content: center;
    width: ${widthFull};
  }
`
Nav.Brand.Link = styled.a`
  align-self: center;
`
Nav.Brand.Logo = styled.img`
  width: ${props => props.resize && !props.resizeOpen ? '42px' : '140px'};
  align-self: center;
  transition: .35s ease;
  max-height: 40px;
  object-fit: contain;

  @media (max-width: 992px) {
    display: none;
  }
`
Nav.Brand.IconSize = styled.div`
  align-self: center;
  padding: 6px 8px;
  cursor: pointer;
  display: ${props => props.resize && !props.resizeOpen ? 'none' : 'flex'};
  justify-content: center;
  font-size: 1.05rem;
  color: #fff;
  border-radius: ${radiusSm};
  transition: background-color 0.15s ease;

  &:hover {
    background-color: rgba(255,255,255,0.1);
  }

  @media (max-width: 992px) {
    display: none;
  }
`
Nav.Brand.IconMobile = styled.div`
  align-self: center;
  display: none;
  padding: 5px;
  font-size: 1.2rem;
  color: #fff;

  @media (max-width: 992px) {
    display: flex;
  }
`
/* End Brand */

/* Start One Level */
Nav.OneLevel = styled.ul`
  padding: 0 10px;
  padding-top: 76px;
  list-style: none;
`
Nav.OneLevel.Item = styled.li`
  padding-bottom: 6px;
  width: ${props => props.resize && !props.resizeOpen ? widthResizeWithPadding : widthWithPadding};

  @media (max-width: 992px) {
    width: ${widthWithPadding};
  }
`
Nav.OneLevel.TitleContent = styled.div`
  display: flex;
  justify-content: ${props => props.resize && !props.resizeOpen ? 'center' : 'space-between'};
  background: ${props => props.active ? primarySoft : 'transparent'};
  color: ${props => props.active ? primary : text};
  border-radius: ${radiusMd};
  padding: 10px 12px;
  cursor: pointer;
  margin-bottom: 4px;
  min-height: 40px;
  font-weight: ${props => props.active ? 600 : 500};
  transition: background-color 0.15s ease, color 0.15s ease;

  &:hover {
    background: ${primarySoft};
    color: ${primary};
  }

  &:hover div {
    padding-left: 6px;
  }

  @media (max-width: 992px) {
    justify-content: space-between;
  }
`
Nav.OneLevel.Title = styled.div`
  align-self: center;
  transition: .25s ease;
  display: flex;
`
Nav.OneLevel.IconArrow = styled.span`
  align-self: center;
  display: ${props => props.resize && !props.resizeOpen ? 'none' : 'inline-block'};
  transform: ${props => props.active ? 'rotate(225deg)' : 'rotate(135deg)'};
  transition: .25s ease;
  content: '';
  width: 5px;
  height: 5px;
  border-width: 1.5px 0 0 1.5px;
  border-style: solid;
  opacity: 0.55;

  @media (max-width: 992px) {
    display: inline-block;
  }
`
Nav.OneLevel.Icon = styled.span`
  margin-right: ${props => props.resize && !props.resizeOpen ? '' : '0.85rem'};
  display: flex;
  width: 20px;
  align-self: center;
  justify-content: center;
  color: ${props => props.active ? primary : muted};

  @media (max-width: 992px) {
    margin-right: 0.85rem;
  }
`
Nav.OneLevel.Description = styled.span`
  display: ${props => props.resize && !props.resizeOpen ? 'none' : 'inline-block'};
  align-self: center;
  font-size: 0.875rem;

  @media (max-width: 992px) {
    display: inline-block;
  }
`
/* End One Level */

/* Start Second Level */
Nav.SecondLevel = styled.ul`
  list-style: none;
  display: ${props => props.resize && !props.resizeOpen ? 'none' : (props.active ? 'block' : 'none')};
  padding-left: 4px;
  @media (max-width: 992px) {
    display: ${props => props.active ? 'block' : 'none'};
  }
`
Nav.SecondLevel.Item = styled.li`
  display: flex;
  justify-content: space-between;
  background: ${props => props.active ? primaryGradient : 'transparent'};
  color: ${props => props.active ? '#fff' : muted};
  box-shadow: ${props => props.active ? shadowActive : 'none'};
  border-radius: ${radiusMd};
  padding: 9px 12px;
  cursor: pointer;
  margin-bottom: 2px;
  font-size: 0.82rem;
  transition: background-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    background: ${props => props.active ? primaryGradient : primarySoft};
    color: ${props => props.active ? '#fff' : primary};
  }

  &:hover div {
    padding-left: 6px;
  }
`
Nav.SecondLevel.Title = styled.div`
  align-self: center;
  transition: .2s ease;
  display: flex;
  height: 20px;
`
Nav.SecondLevel.Icon = styled.span`
  margin-right: 0.85rem;
  align-self: center;
  display: flex;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  border: 1.5px solid currentColor;
  opacity: 0.7;
`
Nav.SecondLevel.Description = styled.span`
  display: ${props => props.resize && !props.resizeOpen ? 'none' : 'inline-block'};
  font-weight: 500;
  width: ${widthWithPadding};
  align-self: center;

  @media (max-width: 992px) {
    display: inline-block !important;
  }
`
/* End Second Level */

export default Nav
